import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Filter out browser extension errors from console
const originalError = console.error;
console.error = (...args: any[]) => {
  const errorMessage = String(args.join(' ')).toLowerCase();
  const errorSource = String(args[0]?.stack || args[0]?.source || args[0]?.filename || '').toLowerCase();
  const firstArg = String(args[0] || '').toLowerCase();
  
  // Filter out common browser extension errors
  // Check error message, source, filename, and first argument
  const isExtensionError = 
    errorMessage.includes('popup.js') ||
    errorMessage.includes('extension://') ||
    errorMessage.includes('chrome-extension://') ||
    errorMessage.includes('moz-extension://') ||
    errorMessage.includes('safari-extension://') ||
    errorSource.includes('popup.js') ||
    errorSource.includes('extension://') ||
    errorSource.includes('chrome-extension://') ||
    errorSource.includes('moz-extension://') ||
    errorSource.includes('safari-extension://') ||
    firstArg.includes('popup.js') ||
    firstArg.includes('extension://') ||
    firstArg.includes('chrome-extension://') ||
    firstArg.includes('moz-extension://') ||
    firstArg.includes('safari-extension://');
  
  if (isExtensionError) {
    // Silently ignore browser extension errors
    return;
  }
  // Log other errors normally
  originalError.apply(console, args);
};

// Also filter window.onerror for extension errors
window.addEventListener('error', (event) => {
  const source = String(event.filename || '').toLowerCase();
  const message = String(event.message || '').toLowerCase();
  
  if (
    source.includes('popup.js') ||
    source.includes('extension://') ||
    source.includes('chrome-extension://') ||
    source.includes('moz-extension://') ||
    source.includes('safari-extension://') ||
    message.includes('popup.js') ||
    (source.includes('.js:') && source.includes('extension'))
  ) {
    event.preventDefault();
    return false;
  }
}, true);

// Also filter unhandled promise rejections from extensions
window.addEventListener('unhandledrejection', (event) => {
  const reason = String(event.reason || '').toLowerCase();
  const stack = String(event.reason?.stack || '').toLowerCase();
  
  if (
    reason.includes('popup.js') ||
    reason.includes('extension://') ||
    reason.includes('chrome-extension://') ||
    reason.includes('moz-extension://') ||
    reason.includes('safari-extension://') ||
    stack.includes('popup.js') ||
    stack.includes('extension://')
  ) {
    event.preventDefault();
    return false;
  }
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
